export {
  useListOrganisationIntegrations,
  type OrganisationIntegration,
} from '@omnea-app/fe-organisation-integrations/useListOrganisationIntegrations'
